/* Desktop hover dropdowns; native click and keyboard access remain available. */
(() => {
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  const getMenu = (target) => target.closest?.('.header__inline-menu header-menu');
  let active = null;
  function open(menu) {
    if (!desktop()) return;
    const details = menu?.querySelector(':scope > details');
    if (!details) return;
    if (active && active !== details) active.open = false;
    details.open = true;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded','true');
    active = details;
  }
  function close(menu) {
    const details = menu?.querySelector(':scope > details');
    if (!details || menu.contains(document.activeElement)) return;
    details.open = false;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded','false');
    if (active === details) active = null;
  }
  document.addEventListener('mouseover', (event) => {
    if (event.target.closest?.('.header__inline-menu .header__submenu')) return;
    const menu = getMenu(event.target);
    if (menu) open(menu);
  });
  document.addEventListener('mouseout', (event) => {
    const menu = getMenu(event.target);
    if (menu && !menu.contains(event.relatedTarget)) close(menu);
  });
  document.addEventListener('focusin', (event) => {
    const menu = getMenu(event.target);
    if (menu) open(menu);
  });
  document.addEventListener('focusout', (event) => {
    const menu = getMenu(event.target);
    if (menu && !menu.contains(event.relatedTarget)) close(menu);
  });
})();